import { useEffect, useState } from "react";

import DashboardDataItem from "shared/components/data-display/dashboards/DashboardDataItem";
import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import VStack from "shared/components/layout/stack/VStack";
import { format } from "date-fns";
import { useBizUnits } from "features/admin/retainers/useRetainers";
import { useClientsApi } from "features/admin/clients/useClients";
import { useRateCard } from "features/projects/retainers-dashboard/single/useRetainersDashboardUserDetails";
import useRetainersDashboardData from "features/projects/retainers-dashboard/single/useRetainersDashboardData";

const RetainersDashboardDetailsData = ({ retainerData }) => {
    const { bizUnits } = useBizUnits();
    const [bizUnitName, setBizUnitName] = useState();
    const currencyDL = useRetainersDashboardData("currency");
    const retainerInfo = retainerData?.data;
    const { useClientById } = useClientsApi();
    const clientData = useClientById(retainerInfo?.ClientID);
    const { useRateCardById } = useRateCard();
    const rateCardData = useRateCardById(retainerInfo?.RateCardTableID);

    useEffect(() => {
        if (!bizUnits.isLoading) {
            const BUName = bizUnits?.data?.filter((f) => {
                return f?.BizUnitID === retainerInfo?.BizUnitID;
            });

            setBizUnitName(BUName[0]?.BUName);
        }
    }, [bizUnits, retainerInfo?.BizUnitID]);

    let dataObj = [
        {
            borderBottom: false,
            data: [
                {
                    title: "Client",
                    placeholder: "-",
                    res: clientData?.data?.Name,
                },
                {
                    title: "Currency",
                    placeholder: "-",
                    res: currencyDL?.list?.data?.Name,
                },
                {
                    title: "Retainer Start Date",
                    placeholder: "-",
                    res: format(
                        new Date(retainerInfo?.RetStartDate),
                        "MMM dd, yyyy"
                    ),
                },
                {
                    title: "SOW Signed",
                    placeholder: "-",
                    res: retainerInfo?.SOWSigned ? "Yes" : "No",
                },
            ],
        },
        {
            borderBottom: false,
            data: [
                {
                    title: "Lead Business Unit",
                    placeholder: "-",
                    res: bizUnitName,
                },
                {
                    title: "Rate Card",
                    placeholder: "-",
                    res: rateCardData?.data?.RateCardTableName,
                },
                {
                    title: "Retainer End Date",
                    placeholder: "-",
                    res: format(
                        new Date(retainerInfo?.RetEndDate),
                        "MMM dd, yyyy"
                    ),
                },
            ],
        },
    ];

    if (
        bizUnits.isLoading ||
        currencyDL.list.isLoading ||
        clientData.isLoading ||
        rateCardData.isLoading
    ) {
        return <>Loading...</>;
    }

    if (
        bizUnits.isError ||
        currencyDL.list.isError ||
        clientData.isError ||
        rateCardData.isError
    ) {
        return <>Error</>;
    }

    return (
        <VStack spacing="Two">
            {dataObj.map((row, rowIndex) => (
                <HStack
                    key={`retainers-data-layout-${rowIndex + 1}`}
                    borderBottom={row.borderBottom}
                    spacing="Two"
                >
                        {row.data.map((item, itemIndex) => {
                            return (
                                <DashboardDataItem
                                    key={`retainers-data-item-${itemIndex + 1}`}
                                    title={item.title}
                                    placeholder={item.placeholder}
                                    info={item.res}
                                    isLoading={retainerData?.isFetching}
                                />
                            );
                        })}
                    </HStack>
                ))}
        </VStack>
    );
};

RetainersDashboardDetailsData.propTypes = {
    retainerData: PropTypes.object
};

export default RetainersDashboardDetailsData;
